module.exports = __webpack_public_path__ + "img/freestyle_box22.d3335b03.jpg";